import React from 'react';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MeetTheBand } from './components/MeetTheBand';
import { Photos } from './components/Photos';
import { Shows } from './components/Shows';
import { SiteHeader } from './components/SiteHeader';
import { WatchListen } from './components/WatchListen';
export function App() {
  return <div className="min-h-full w-full bg-[var(--vu-black)] font-body text-[var(--vu-cream)] selection:bg-[var(--vu-gold)] selection:text-[var(--vu-black)]" data-id="element-0" data-mp="2rlozuqfd2dda">
      <SiteHeader data-id="element-1" data-mp="31aqh0jxn70su" />
      <Hero data-id="element-2" data-mp="31ayry6a7fw1e" />
      <MeetTheBand data-id="element-3" data-mp="31bs0ncsq4vm6" />
      <Shows data-id="element-4" data-mp="31c9u61o04vqe" />
      <WatchListen data-id="element-5" data-mp="31ctd9lpe1q60" />
      <Photos data-id="element-6" data-mp="2wk0bn6p7uxy5" />
      <Contact data-id="element-7" data-mp="2wjgrdjc3fxgy" />
      <Footer data-id="element-8" data-mp="2wiyxuugtfxcq" />
    </div>;
}